module.exports = __webpack_public_path__ + "img/logo-avatar-color.356d8288.png";